import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getUserCountryCode} from 'modules/meta/selectors'
import {setTaxConfigDangerously} from 'modules/meta/slice'
import {toggle} from 'opticks'

import {getTaxDisplayLogic} from '@daedalus/core/src/localization/business/countries'

// Added as part of feature-enable-partial-taxes-in-us
// More context: https://app.shortcut.com/findhotel/story/151759/feature-toggle-enable-partial-taxes-in-us

export const EnablePartialTaxes = () => {
  const dispatch = useDispatch()
  const userCountryCode = useSelector(getUserCountryCode)

  useEffect(() => {
    if (
      ['US'].includes(userCountryCode) &&
      toggle('feature-enable-partial-taxes-in-us', false, true)
    ) {
      const {includeTaxes} = getTaxDisplayLogic(userCountryCode)
      dispatch(
        setTaxConfigDangerously({
          includeTaxes,
          includeLocalTaxes: true
        })
      )
    }
  }, [dispatch, userCountryCode])

  return null
}
